import { Organization } from "@/types";
import { Collapse, Paper, Stack, TextField, Tooltip, Typography, IconButton, styled } from "@mui/material";
import { useFormikContext } from "formik";
import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { useState } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const ExpandMore = styled(IconButton)(({ theme, expand }: { theme: any; expand: boolean }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
    }),
}));

const OperationTimingSettings = () => {
    const { values, setFieldValue } = useFormikContext<Organization>();
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Paper sx={{ padding: 2 }}>
            <Stack spacing={{ xs: 3, md: 2 }} direction={{ md: "row" }} alignItems={"center"} justifyContent={"space-between"}>
                <Stack>
                    <Typography variant="h4">Tiempos de operación</Typography>
                </Stack>
                <Stack spacing={2} direction={"row"} alignItems={"center"} justifyContent={"flex-end"}>
                    <ExpandMore expand={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                        <Tooltip title={isExpanded ? "Contraer" : "Expandir"}>
                            <HugeiconsIcon icon={ArrowDown01Icon} />
                        </Tooltip>
                    </ExpandMore>
                </Stack>
            </Stack>

            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={2} mt={2}>
                        <Stack direction="row" spacing={3}>
                            <TextField
                                label="Revisión"
                                type="number"
                                value={values?.settings?.operationTiming?.review}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    setFieldValue("settings.operationTiming.review", value)
                                }}
                            />
                            <TextField
                                label="Preparación"
                                type="number"
                                value={values?.settings?.operationTiming?.preparation}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    setFieldValue("settings.operationTiming.preparation", value)
                                }}
                            />
                            <TextField
                                label="Envío"
                                type="number"
                                value={values?.settings?.operationTiming?.shipping}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    setFieldValue("settings.operationTiming.shipping", value)
                                }}
                            />
                        </Stack>
                        <Typography variant="body2" color="text.secondary">
                            Define los tiempos meta (en minutos). El sistema los usará para comparar el desempeño real y generar tus métricas de eficiencia.
                        </Typography>
                    </Stack>
                </LocalizationProvider>
            </Collapse>
        </Paper>

    );
};

export default OperationTimingSettings; 